/**
 * Publieke doorgeefroute voor foto's uit de afgeschermde opslag.
 * Alleen lezen, alleen bestanden uit de bucket blog-images.
 * Originelen ("…-origineel.<ext>") worden nooit geleverd: die kunnen GPS-gegevens bevatten.
 * Foto's met personen worden altijd geleverd: de eigenaar heeft steeds toestemming.
 */
import { isOriginalPath } from "@/lib/media-originals";
import { createFileRoute } from "@tanstack/react-router";

const notFound = () =>
  new Response("Not found", { status: 404, headers: { "Cache-Control": "no-store" } });

export const Route = createFileRoute("/api/public/blog-image/$")({
  staticData: { sitemap: false },
  server: {
    handlers: {
      GET: async ({ params }) => {
        const path = (params as { _splat?: string })._splat ?? "";
        if (!path || path.includes("..") || isOriginalPath(path)) return notFound();
        const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
        const { data, error } = await supabaseAdmin.storage.from("blog-images").download(path);
        if (error || !data) return notFound();
        return new Response(await data.arrayBuffer(), {
          headers: {
            "Content-Type": data.type || "image/jpeg",
            "Cache-Control": "public, max-age=31536000, immutable",
          },
        });
      },
    },
  },
});
